import React from "react";

export const CloseIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M26.8701 8.48528L18.3848 16.9706L9.89949 8.48528L8.48528 9.89949L16.9706 18.3848L8.48528 26.8701L9.89949 28.2843L18.3848 19.799L26.8701 28.2843L28.2843 26.8701L19.799 18.3848L28.2843 9.89949L26.8701 8.48528Z"
      fill="currentColor"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/containers/HomePage/CloseIcon.tsx